<template lang="pug">
  section.HorizontalScrollView
    .HorizontalScrollView_bg
      PageTransitionLayer(:backgroundColor="COLOR.DARK" backgroundImg="none")
      BackgroundRelief
      .HorizontalScrollView_bgTile.HorizontalScrollView_bgTile-back(ref="bgTileBack")
      .HorizontalScrollView_bgTile.HorizontalScrollView_bgTile-front(ref="bgTileFront")
    .HorizontalScrollView_content(:style="contentStyle")
      .HorizontalScrollView_list(ref="list")
        router-view(:title="$t(itemType+'.title')")
</template>

<script>

import customTransitionMixins from '@/mixins/customTransitionMixins'
import PageTransitionLayer from '@/components/PageTransitionLayer'
import COLOR from '@/const.colors.js'
import { mapGetters } from 'vuex'
import BackgroundRelief from '@/components/common/BackgroundRelief'

export default {
  mixins: [customTransitionMixins],
  components: {
    PageTransitionLayer,
    BackgroundRelief
  },
  props: {
    itemType: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      COLOR
    }
  },
  computed: {
    ...mapGetters([
      'viewportSize'
    ]),
    contentStyle () {
      return {
        height: this.viewportSize.height + 'px'
      }
    }
  },
  beforeDestroy () {
    // Au cas où l'animation d'apparition ne soit pas finie
    // on l'arrète et la supprime
    if (this._animTimeline) {
      this._animTimeline.kill()
      this._animTimeline = null
    }
  },
  methods: {
    /**
     * Override la méthode transitionIn de customTransitionMixins
     * Afin de définir une animation custom
     *
     * @args {Function} ended - callback à appeler une fois l'animation terminée
     */
    transitionIn (next) {
      const timeline = new TimelineLite({onComplete: () => {
        next()
      }})

      timeline.fromTo(this.$refs.bgTileFront, 1.6, {
        opacity: 0
      }, {
        opacity: 1
      })

      // timeline.fromTo(this.$refs.title, 1.6, {
      //   opacity: 0,
      //   x: '25%'
      // }, {
      //   opacity: 1,
      //   x: '0%'
      // }, 0.2)

      timeline.fromTo(this.$refs.bgTileBack, 1.6, {
        opacity: 0,
        x: '25%',
        y: '-25%'
      }, {
        opacity: 1,
        x: '0%',
        y: '-50%',
        opacity: 1
      }, 0.2)

      timeline.fromTo(this.$refs.list, 1.6, {
        opacity: 0,
        x: 200
      }, {
        opacity: 1,
        x: 0,
        clearProps: 'transform, opacity'
      }, 0.6)

      // On sauvegarde la timeline pour plus tard
      this._animTimeline = timeline
    }
  }
}
</script>

<style lang="stylus" scope>
.HorizontalScrollView
  page_horizontal_gutter = 8vw

  position relative
  overflow hidden

  &_bg
    position: absolute
    top 0
    right 0
    bottom 0
    left 0

    .HorizontalScrollView_bgTile-back
      content ''
      position: absolute
      width 200%
      height 400%
      top: 50%
      left: 50%
      background-color #191919
      transform-origin 0 50%
      transform translate(0, -50%) rotateZ(45deg)
      // filter: invert(50%)
      mix-blend-mode soft-light

    .HorizontalScrollView_bgTile-front
      content ''
      position: absolute
      top 0
      right 0
      bottom 0
      left 0
      // background-image url('/img/backgrounds/horizontalscrollpage_bgpattern_light.png')
      background-repeat no-repeat
      background-size auto 100%
      background-position 100% 50%
      background-blend-mode overlay

  &_content
    position relative
    height 100vh
    width 100%

  &_title
    font-size font_size = 7.5vw
    line-height: font_size
    position absolute
    top 0
    left page_horizontal_gutter
    right page_horizontal_gutter
    bottom 0
    color white
    display flex
    justify-content flex-start
    align-items center

    &_mobile
      font-size font_size = 7.5vw
      line-height: font_size
      top 0
      margin-left page_horizontal_gutter
      color white
      position absolute
      margin-top 7.5vw

  &_list
    position absolute
    top 0
    bottom 0
    right 0
    left 0

  .HorizontalScrollList
    position absolute
    top 0
    bottom 0
    left 0
    right 0

    &_carousel
      padding-left 'calc(100% - %s)' % (page_horizontal_gutter * 3)
      padding-right (page_horizontal_gutter * 1.5)

</style>
